'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';

var searchCompanyIndustries = function (msBaseUrl, keyword) { return __awaiter(void 0, void 0, void 0, function () {
    var api, requestOptions, response, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                api = "".concat(msBaseUrl, "/meta/v1.2/search-company-industries?keyword=").concat(keyword);
                requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                return [4 /*yield*/, fetch(api, requestOptions)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                err_1 = _a.sent();
                console.error(err_1);
                return [2 /*return*/, {
                        data: [],
                        meta: {
                            statusCode: 400
                        }
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };

export { searchCompanyIndustries };
//# sourceMappingURL=services.js.map
